import { Component, OnInit,ViewChild } from '@angular/core';
import { ForgetPasswordPageService,forgotPassWord } from '../../services/forget-password-page.service';  
import {HelperService} from '../../../shared/services/helper.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http'; 
import { Configuration } from '../../../app.constants';
import { asapScheduler } from 'rxjs';
import { toASCII } from 'punycode';
import {
DxFormComponent } from 'devextreme-angular';
import { Ordinance } from 'src/app/registration/services/ordinance.service';
import { error } from 'util';
import { AuthService, AppInfoService, PortalStudentLogIn } from '../../../shared/services';
import { AppConfigService } from '../../../app-config.service';


@Component({
  selector: 'forget-password-page',
  templateUrl: './forget-password-page.component.html',
  styleUrls: ['./forget-password-page.component.scss'],
  providers:[ForgetPasswordPageService,HelperService]
})
export class ForgetPasswordPageComponent implements OnInit {
  @ViewChild(DxFormComponent) myform:DxFormComponent
  isVisible:boolean=false;
  isVerify:boolean=false;
  otpVerify = '';
  buttonOptions: any = {
  text: "Submit",
  type:  "success",
  useSubmitBehavior: true,
  height:40,
  width:200,
  onClick:'saveRecord'
}
public logoPath :string="";
btngendisabled:boolean=false;
forgetPasswordData:forgotPassWord
dataSource:any;
dataSource1:any;
errorMessage: string[] = new Array(); 
isValid:boolean;
Password = "";
OTPdisabled:boolean=true;
StudMaildisabled:boolean=false;
Mobdisabled:boolean=false;
btnverdisabled:boolean=true;
btnsubDis:boolean=true;
passwordOptions: any = {
  mode: "password",
  value: this.Password
};
Pattern1: any =/^[^<>]+$/;
Universitydata:any;
LanguageLabel:any;

  constructor(private http:HttpClient,
    private router: Router,private route: ActivatedRoute,
    private forgetPasswordPageService:ForgetPasswordPageService,
     private authService: AuthService, private configuration: Configuration,
     private helperService:HelperService,
     private appConfigService : AppConfigService  
     ) {
       this.logoPath = this.appConfigService.LogoPath;
      }

  ngOnInit() {
    this.LanguageLabel =this.configuration.LanguageLabel[0];
  this.forgetPasswordData={
    StudeMailId :"",
    MobileNo:"",
    PreExamOtpId:0,
    MoblieOTP: "",
    confirmPassword:"",
    Password:"",
    Password1:""
    } 
    this.errorMessage=[];
    this.authService.GetSystemUniversityForFlag("Flag5")
    .subscribe((data: PortalStudentLogIn[]) => this.Universitydata = data,
    error => {
      //alert(error);
    },
    () => {
      ;
      if(this.Universitydata.length > 0){
      this.configuration.UniversityFlag=this.Universitydata[0].Flag;
      }
    });  
  }
  generatemobOTP(){
     if(this.configuration.UniversityFlag=="Y"){
      if(this.forgetPasswordData.StudeMailId==undefined||this.forgetPasswordData.StudeMailId==null){
        this.helperService.showWarningMessage("First Enter User Name.");    
        return false;
      }
    }
    if(this.configuration.UniversityFlag=="N"){
      if ((this.forgetPasswordData.StudeMailId=="") || (this.forgetPasswordData.StudeMailId==null))
      {
        this.helperService.showWarningMessage("First Enter User Name.");    
        return false;
      }
    }
   
    if ((this.forgetPasswordData.MobileNo=="") || (this.forgetPasswordData.MobileNo==null))
    {
      this.helperService.showWarningMessage("First Enter Mobile No.");   
      return false;
    }
    this.btnsubDis=true;
    this.btnverdisabled=true;
    this.OTPdisabled=true;
    this.Mobdisabled=false;
    this.StudMaildisabled=false;
    this.forgetPasswordData.MoblieOTP="";
    this.forgetPasswordData.StudeMailId=this.forgetPasswordData.StudeMailId.trim();
    //this.forgetPasswordData.MobileNo=this.forgetPasswordData.MobileNo.trim();
    this.forgetPasswordPageService.GenerateMobOTP(this.forgetPasswordData.StudeMailId,this.forgetPasswordData.MobileNo)
    .subscribe((data: forgotPassWord[]) => this.dataSource = data,
    err => {
     
      this.isVisible=false;
      var error = this.helperService.getErrorMessage(err)
         if ((this.dataSource==null)||(this.dataSource==undefined) ||(this.dataSource==0))
       {
        this.helperService.showWarningMessage("Invalid UserName And Mobile No."); 
        this.forgetPasswordData.StudeMailId="";
        this.forgetPasswordData.MobileNo="";
        return false
       }  
   },
  () => {
    
    if (this.dataSource[0].validuser==1)
    {
      this.helperService.showWarningMessage("Invalid UserName And Mobile No."); 
      return;
    }
  
        this.forgetPasswordData.MobileNo=this.dataSource[0].MobileNo;
        this.isVisible = true;
        this.Mobdisabled=true
        this.StudMaildisabled=true;
        this.btnverdisabled=false;
        this.OTPdisabled=false;
       });   

  }
  OTPVerify() {
    if(this.configuration.UniversityFlag=="Y"){
      if(this.forgetPasswordData.StudeMailId==undefined||this.forgetPasswordData.StudeMailId==null){
        this.helperService.showWarningMessage("First Enter User Name.");    
        return false;
      }
    }
    if(this.configuration.UniversityFlag=="N"){
      if ((this.forgetPasswordData.StudeMailId=="") || (this.forgetPasswordData.StudeMailId==null))
      {
        this.helperService.showWarningMessage("First Enter User Name.");    
        return false;
      }
    }
  
    if ((this.forgetPasswordData.MobileNo=="") || (this.forgetPasswordData.MobileNo==null))
    {
      this.helperService.showWarningMessage("First Enter Mobile No.");   
      return false;
    }
    if ((this.forgetPasswordData.MoblieOTP=="") || (this.forgetPasswordData.MoblieOTP==null))
    {
      this.helperService.showWarningMessage("First Enter Mobile OTP.");   
      return false;
    }
    this.OTPdisabled=false;
    this.btnverdisabled=false;
    this.forgetPasswordPageService. VerifyMobOTP( this.forgetPasswordData.MobileNo,this.forgetPasswordData.MoblieOTP)
    .subscribe((data: forgotPassWord[]) => this.dataSource1 = data,
    err => {
      
      this.errorMessage=this.helperService.getErrorMessage(err);
      this.isVerify = false;
      if ((this.dataSource1==null)||(this.dataSource1==undefined) ||(this.dataSource1==0))
      {
       this.helperService.showWarningMessage("Incorrect OTP Entered."); 
       this.forgetPasswordData.MoblieOTP="";
       return false
      }
      },
      () => {
        
        if ((this.dataSource1==null)||(this.dataSource1==undefined) ||(this.dataSource1==0))
        {
          this.isVerify = false;
         this.helperService.showWarningMessage("Incorrect OTP Entered."); 
         this.forgetPasswordData.MoblieOTP="";
         return false
        }
        else
        {
          this.isVerify = true;
          this.helperService.showSuccessMessage("Your OTP Verified Successfully.");   
          this.OTPdisabled=true;
          this.btnverdisabled=true;
          this.btnsubDis=false;
        }
      
      });
  }
  passwordComparison = () => {
    return this.myform.instance.option("formData").Password;
  };
  passwordlengthComparison=()=>{
   if(this.myform.instance.option("formData").Password.length<8){
   return true;
   }
  };
  checkComparison() {
    return true;
  }
  saveRecord() {
    if(this.configuration.UniversityFlag=="Y"){
      if(this.forgetPasswordData.StudeMailId==undefined||this.forgetPasswordData.StudeMailId==null){
        this.forgetPasswordData.StudeMailId=="";
      }
    }
    if(this.configuration.UniversityFlag=="N"){
    if ((this.forgetPasswordData.StudeMailId=="") || (this.forgetPasswordData.StudeMailId==null))
    {
      this.helperService.showWarningMessage("First Enter User Name.");    
      return false;
    }
  }
    if ((this.forgetPasswordData.MobileNo=="") || (this.forgetPasswordData.MobileNo==null))
    {
      this.helperService.showWarningMessage("First Enter Mobile No.");   
      return false;
    }
    if ((this.forgetPasswordData.MoblieOTP=="") || (this.forgetPasswordData.MoblieOTP==null))
    {
      this.helperService.showWarningMessage("First Enter Mobile OTP.");   
      return false;
    }
    this.forgetPasswordData.Password1=window.btoa(this.forgetPasswordData.Password);
    this.forgetPasswordData.confirmPassword=window.btoa(this.forgetPasswordData.confirmPassword);
    this.isValid = this.myform.instance.validate().isValid;
    if(this.isValid == true) {
        this.errorMessage=[];
          this.forgetPasswordPageService.update(this.forgetPasswordData)
            .subscribe(value => {
              this.onSuccessSave();
            },
              err => {
                this.errorMessage=this.helperService.getErrorMessage(err);
                alert(this.errorMessage);
              },
              () => {
              
              });
      }
   }
   onSuccessSave() {
    this.helperService.showSuccessMessage("Your Password Changed Successfully.");    
    this.router.navigate(['/login-form']);
  }
  cancelClick(){
    this.errorMessage=[];
    this.router.navigate(['/login-form']);
  }
  
  redirectToLogin(){
    this.router.navigate(['/login-form']);  
  }

}
